/**
 * Marker attribute used by the popup's outside-click handler to know a click
 * landed inside a submenu (submenus are rendered via a portal into document.body,
 * so they are not descendants of the popup's own ref).
 */
export const POPUP_SUBMENU_MARKER_ATTR = 'data-popup-submenu';

export const SUBMENU_HOVER_DELAY_MS = 300;
